<template>
    <div class="remove-api-key">
        <h4 class="td-h4">Are you sure you want remove this API Key?</h4>
        <p style="margin-top: 15px;"><strong>Name:</strong> {{ model.name }}</p>
        <p style="margin-top: 10px;"><strong>Api Key:</strong> {{ model.apiKey }}</p>
        <br /><br /><br />
        <div style="margin-top: 25px;" class="actions">
            <button class="danger td-btn" title="Yes - REMOVE" @click.prevent="removeApiKey">Yes - REMOVE</button>
        </div>
    </div>
</template>

<script>
    import script from './RemoveApiKey';
    export default script;
</script>

<style lang="less">
    @import "./RemoveApiKey.less";
</style>